export default __webpack_public_path__ + "static/media/config-hris-bu.f84ce689.svg";